export enum Routes {
  LOGIN = "/auth/login",
  COURSES = "/my-courses",
  PROFILE = "/profile",
  START = "/course",
  NO_ACCESS = "/no-access",
}
